import { render, staticRenderFns } from "./InventoryMainSku.vue?vue&type=template&id=68f2580c&"
import script from "./InventoryMainSku.vue?vue&type=script&lang=js&"
export * from "./InventoryMainSku.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports